<template>
  <flow-builder />
</template>

<script>
import Flow from './components/Flow'

export default {
  name: 'App',
  components: {
    'flow-builder': Flow,
  }
}
</script>
